import { z } from 'zod';

// ── Inteligência artificial (DESIGN-V11 §5) ─────────────────────────────────
// Modelo NOSSO ≠ créditos TiFlux: cada tenant configura a PRÓPRIA chave
// Anthropic. A key nunca volta inteira (padrão maskApiKey das integrações).

export const AiModelSchema = z.enum(['claude-sonnet-5', 'claude-haiku-4-5']);
export type AiModel = z.infer<typeof AiModelSchema>;

export const AI_MODEL_LABELS: Record<AiModel, string> = {
  'claude-sonnet-5': 'Claude Sonnet 5 (recomendado)',
  'claude-haiku-4-5': 'Claude Haiku 4.5 (mais rápido)',
};

export const AI_DEFAULT_MODEL: AiModel = 'claude-sonnet-5';

/**
 * Timeout do client HTTP da API para a inferência (30s — inferência é lenta;
 * os 10s default do service-fetch derrubariam completions legítimas). Vive no
 * shared para o web orçar o PRÓPRIO timeout ACIMA deste valor — um timeout de
 * UI menor cancelaria a espera antes de a API decidir.
 */
export const AI_REQUEST_TIMEOUT_MS = 30_000;

/** GET /ai/integration (admin) */
export const AiIntegrationSchema = z.object({
  apiKeyMasked: z.string().nullable(),
  model: AiModelSchema,
  active: z.boolean(),
});
export type AiIntegration = z.infer<typeof AiIntegrationSchema>;

/** PUT parcial: apiKey obrigatória só na PRIMEIRA configuração (422
 *  api_key_required quando não há linha ainda) — padrão finance_integrations. */
export const AiIntegrationPutBodySchema = z.object({
  apiKey: z.string().min(1).optional(),
  model: AiModelSchema.optional(),
  active: z.boolean().optional(),
});
export type AiIntegrationPutBody = z.infer<typeof AiIntegrationPutBodySchema>;

/** GET /ai/status (staff): alimenta a visibilidade dos botões de IA no ticket */
export const AiStatusSchema = z.object({ active: z.boolean() });
export type AiStatus = z.infer<typeof AiStatusSchema>;

/** POST /tickets/:n/ai/suggest e /tickets/:n/ai/summary */
export const AiTextSchema = z.object({ text: z.string() });
export type AiText = z.infer<typeof AiTextSchema>;

/** códigos de erro das rotas de IA → mensagem pt-BR (toasts do web) */
export const AI_ERROR_LABELS: Record<string, string> = {
  ai_not_configured: 'Integração de IA não configurada ou inativa.',
  ai_error: 'O provedor de IA respondeu com erro. Tente novamente.',
};
